import { Component, OnInit, Input } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import { ObsService } from '../../../core/http/obs.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as _moment from 'moment';
const moment = _moment;

@Component({
  selector: 'app-second-trimester',
  templateUrl: './second-trimester.component.html',
  styleUrls: ['./second-trimester.component.scss'],
})
export class SecondTrimesterComponent implements OnInit {
  @Input() Patient_type;
  @Input() gender;
  @Input() AmnioticFluid;
  @Input() CervicalOs;
  @Input() Chorionicity;
  @Input() Amnionicity;
  @Input() Grade;
  @Input() PlacentaLocation;
  @Input() PlacentaLocationAnatomic;
  @Input() Presentation;
  @Input() FetalAnomaly;
  @Input() NoofFetus;
  @Input() TechnicalConditions;
  @Input() FetalHeartBeat;
  @Input() image1;
  @Input() image2;
  @Input() fetal_movement;
  @Input() disable;

  repeat = false;
  trimister = false;
  copy = false;
  isLoading = false;
  labelPosition = '';
  response: any = [];
  result_id;
  form: FormGroup;
  patient;
  FetchPatient;
  drs: any = [];
  firstPic;
  firstPic2;
  fullImage;
  fullImage2;
  result: any = [];
  disabled: boolean = true;
  data: any = [];
  fetus = '';

  constructor(
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public auth: SettingsService,
    private obs: ObsService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.obs.getDropdownValues(14).subscribe(
      (resSuccess) => {
        this.AmnioticFluid = resSuccess;
      },
      (resErr) => {}
    );
    this.patient = this.obs._patient;
    console.log(this.patient);

    this.obs.getPatient(this.patient.patient_id).subscribe(
      (resSuccess) => {
        console.log(resSuccess);

        this.FetchPatient = resSuccess[0];
        this.form.patchValue({
          result_id: this.patient.result_id,
          data: {
            patient_id: this.patient.patient_id,
            referance_id: this.FetchPatient.ref_doct_code,
            branch_code: this.FetchPatient.Branch_Code,
            author_id: this.FetchPatient.Author_id,
          },
        });
        this.fetchResult();
        console.log(this.form.value);
        console.log(this.FetchPatient);
      },
      (resErr) => {}
    );

    this.obs.getDrs().subscribe(
      (resSuccess) => {
        this.drs = resSuccess;
      },
      (resErr) => {}
    );

    this.form = this.fb.group({
      result_id: [0],
      data: this.fb.group({
        STremester_id: [0],
        patient_id: [''],
        referance_id: [''],
        author_id: [''],
        branch_code: [''],
        sex: [''],
        lmp: [''],
        ga: [''],
        edd: [''],
        tech_cond: [''],
        no_of_fetus: [''],
        chorionicity: [''],
        p_location: [''],
        cervicalos: [''],
        fetal_mment: [''],
        a_fluid: [''],
        bd_mm: [''],
        bd_ga: [''],
        fdl_mm: [''],
        fdl_ga: [''],
        ac_mm: [''],
        ac_ga: [''],
        hc_mm: [''],
        hc_ga: [''],
        g_age: [''],
        efw: [''],
        exdd: [''],
        finding: [''],
        conclusion1: [false],
        conclusion2: [false],
        conclusion3: [false],
        fetus: [''],
        ftimage: [''],
        fin_year: [''],
        entry_date: [''],
        update_entry_date: [''],
        doctor_id: [''],
      }),
      metric: this.fb.group({
        cat_id: [0],
        STremester_id: [0],
        head_shape_n: ['O'],
        head_shape_ab: ['O'],
        head_shape_nv: ['O'],
        head_cavum_n: ['O'],
        head_cavum_ab: ['O'],
        head_cavum_nv: ['O'],
        head_midline_n: ['O'],
        head_midline_ab: ['O'],
        head_midline_nv: ['O'],
        head_thalami_n: ['O'],
        head_thalami_ab: ['O'],
        head_thalami_nv: ['O'],
        head_lateral_n: ['O'],
        head_lateral_ab: ['O'],
        head_lateral_nv: ['O'],
        head_cere_n: ['O'],
        head_cere_ab: ['O'],
        head_cere_nv: ['O'],
        face_upp_n: ['O'],
        face_upp_ab: ['O'],
        face_upp_nv: ['O'],
        face_orbit_n: ['O'],
        face_orbit_ab: ['O'],
        face_orbit_nv: ['O'],
        face_nose_n: ['O'],
        face_nose_ab: ['O'],
        face_nose_nv: ['O'],
        neck1: ['O'],
        neck2: ['O'],
        neck3: ['O'],
        tho_shape_n: ['O'],
        tho_shape_ab: ['O'],
        tho_shape_nv: ['O'],
        tho_mass_n: ['O'],
        tho_mass_ab: ['O'],
        tho_mass_nv: ['O'],
        heart_activity_n: ['O'],
        heart_activity_ab: ['O'],
        heart_activity_nv: ['O'],
        heart_size_n: ['O'],
        heart_size_ab: ['O'],
        heart_size_nv: ['O'],
        heart_cadic_n: ['O'],
        heart_cadic_ab: ['O'],
        heart_cadic_nv: ['O'],
        heart_chamber_n: ['O'],
        heart_chamber_ab: ['O'],
        heart_chamber_nv: ['O'],
        abdo_dia_n: ['O'],
        abdo_dia_ab: ['O'],
        abdo_dia_nv: ['O'],
        abdo_sto_n: ['O'],
        abdo_sto_ab: ['O'],
        abdo_sto_nv: ['O'],
        abdo_bowel_n: ['O'],
        abdo_bowel_ab: ['O'],
        abdo_bowel_nv: ['O'],
        abdo_kidney_n: ['O'],
        abdo_kidney_ab: ['O'],
        abdo_kidney_nv: ['O'],
        abdo_unary_n: ['O'],
        abdo_unary_ab: ['O'],
        abdo_unary_nv: ['O'],
        abdo_insert_n: ['O'],
        abdo_insert_ab: ['O'],
        abdo_insert_nv: ['O'],
        abdo_vessel_n: ['O'],
        abdo_vessel_ab: ['O'],
        abdo_vessel_nv: ['O'],
        spine1: ['O'],
        spine2: ['O'],
        spine3: ['O'],
        limbs_ra_n: ['O'],
        limbs_ra_ab: ['O'],
        limbs_ra_nv: ['O'],
        limbs_rl_n: ['O'],
        limbs_rl_ab: ['O'],
        limbs_rl_nv: ['O'],
        limbs_la_n: ['O'],
        limbs_la_ab: ['O'],
        limbs_la_nv: ['O'],
        limbs_ll_n: ['O'],
        limbs_ll_ab: ['O'],
        limbs_ll_nv: ['O'],
        gender: [''],
      }),
    });
  }

  fetchResult() {
    this.obs.getST(this.patient.result_id).subscribe(
      (resSuccess) => {
        this.result = resSuccess;
        this.data = resSuccess;
        console.log(resSuccess);
        console.log(this.result[0].data.conclusion1);
        console.log(this.result[0].data.conclusion2);
        console.log(this.result[0].data.conclusion3);
        if (
          this.result[0].data.conclusion1 === 'false' ||
          this.result[0].data.conclusion1 === ''
        ) {
          this.form.patchValue({
            data: {
              conclusion1: false,
            },
          });
        } else {
          this.form.patchValue({
            data: {
              conclusion1: true,
            },
          });
        }
        if (
          this.result[0].data.conclusion2 === 'false' ||
          this.result[0].data.conclusion2 === ''
        ) {
          this.form.patchValue({
            data: {
              conclusion2: false,
            },
          });
        } else {
          this.form.patchValue({
            data: {
              conclusion2: true,
            },
          });
        }
        if (
          this.result[0].data.conclusion3 === 'false' ||
          this.result[0].data.conclusion3 === ''
        ) {
          this.form.patchValue({
            data: {
              conclusion3: false,
            },
          });
        } else {
          this.form.patchValue({
            data: {
              conclusion3: true,
            },
          });
        }
        this.form.patchValue({
          data: {
            STremester_id: this.result[0].data.STremester_id,
            lmp: this.result[0].data.lmp,
            ga: this.result[0].data.ga,
            edd: this.result[0].data.edd,
            tech_cond: this.result[0].data.tech_cond,
            sex: this.result[0].data.sex,
            no_of_fetus: this.result[0].data.no_of_fetus,
            chorionicity: this.result[0].data.chorionicity,
            p_location: this.result[0].data.p_location,
            cervicalos: this.result[0].data.cervicalos,
            fetal_mment: this.result[0].data.fetal_mment,
            a_fluid: this.result[0].data.a_fluid,
            bd_mm: this.result[0].data.bd_mm,
            bd_ga: this.result[0].data.bd_ga,
            fdl_mm: this.result[0].data.fdl_mm,
            fdl_ga: this.result[0].data.fdl_ga,
            ac_mm: this.result[0].data.ac_mm,
            ac_ga: this.result[0].data.ac_ga,
            hc_mm: this.result[0].data.hc_mm,
            hc_ga: this.result[0].data.hc_ga,
            g_age: this.result[0].data.g_age,
            efw: this.result[0].data.efw,
            exdd: this.result[0].data.exdd,
            finding: this.result[0].data.finding,
            fetus: this.result[0].data.fetus,
            ftimage: this.result[0].data.ftimage,
            fin_year: this.result[0].data.fin_year,
            entry_date: this.result[0].data.entry_date,
            update_entry_date: this.result[0].data.update_entry_date,
            doctor_id: this.result[0].data.doctor_id,
          },
          metric: {
            cat_id: this.result[0].metric.cat_id,
            STremester_id: this.result[0].metric.STremester_id,
            head_shape_n: this.result[0].metric.head_shape_n || 'O',
            head_shape_ab: this.result[0].metric.head_shape_ab || 'O',
            head_shape_nv: this.result[0].metric.head_shape_nv || 'O',
            head_cavum_n: this.result[0].metric.head_cavum_n || 'O',
            head_cavum_ab: this.result[0].metric.head_cavum_ab || 'O',
            head_cavum_nv: this.result[0].metric.head_cavum_nv || 'O',
            head_midline_n: this.result[0].metric.head_midline_n || 'O',
            head_midline_ab: this.result[0].metric.head_midline_ab || 'O',
            head_midline_nv: this.result[0].metric.head_midline_nv || 'O',
            head_thalami_n: this.result[0].metric.head_thalami_n || 'O',
            head_thalami_ab: this.result[0].metric.head_thalami_ab || 'O',
            head_thalami_nv: this.result[0].metric.head_thalami_nv || 'O',
            head_lateral_n: this.result[0].metric.head_lateral_n || 'O',
            head_lateral_ab: this.result[0].metric.head_lateral_ab || 'O',
            head_lateral_nv: this.result[0].metric.head_lateral_nv || 'O',
            head_cere_n: this.result[0].metric.head_cere_n || 'O',
            head_cere_ab: this.result[0].metric.head_cere_ab || 'O',
            head_cere_nv: this.result[0].metric.head_cere_nv || 'O',
            face_upp_n: this.result[0].metric.face_upp_n || 'O',
            face_upp_ab: this.result[0].metric.face_upp_ab || 'O',
            face_upp_nv: this.result[0].metric.face_upp_nv || 'O',
            face_orbit_n: this.result[0].metric.face_orbit_n || 'O',
            face_orbit_ab: this.result[0].metric.face_orbit_ab || 'O',
            face_orbit_nv: this.result[0].metric.face_orbit_nv || 'O',
            face_nose_n: this.result[0].metric.face_nose_n || 'O',
            face_nose_ab: this.result[0].metric.face_nose_ab || 'O',
            face_nose_nv: this.result[0].metric.face_nose_nv || 'O',
            neck1: this.result[0].metric.neck1 || 'O',
            neck2: this.result[0].metric.neck2 || 'O',
            neck3: this.result[0].metric.neck3 || 'O',
            tho_shape_n: this.result[0].metric.tho_shape_n || 'O',
            tho_shape_ab: this.result[0].metric.tho_shape_ab || 'O',
            tho_shape_nv: this.result[0].metric.tho_shape_nv || 'O',
            tho_mass_n: this.result[0].metric.tho_mass_n || 'O',
            tho_mass_ab: this.result[0].metric.tho_mass_ab || 'O',
            tho_mass_nv: this.result[0].metric.tho_mass_nv || 'O',
            heart_activity_n: this.result[0].metric.heart_activity_n || 'O',
            heart_activity_ab: this.result[0].metric.heart_activity_ab || 'O',
            heart_activity_nv: this.result[0].metric.heart_activity_nv || 'O',
            heart_size_n: this.result[0].metric.heart_size_n || 'O',
            heart_size_ab: this.result[0].metric.heart_size_ab || 'O',
            heart_size_nv: this.result[0].metric.heart_size_nv || 'O',
            heart_cadic_n: this.result[0].metric.heart_cadic_n || 'O',
            heart_cadic_ab: this.result[0].metric.heart_cadic_ab || 'O',
            heart_cadic_nv: this.result[0].metric.heart_cadic_nv || 'O',
            heart_chamber_n: this.result[0].metric.heart_chamber_n || 'O',
            heart_chamber_ab: this.result[0].metric.heart_chamber_ab || 'O',
            heart_chamber_nv: this.result[0].metric.heart_chamber_nv || 'O',
            abdo_dia_n: this.result[0].metric.abdo_dia_n || 'O',
            abdo_dia_ab: this.result[0].metric.abdo_dia_ab || 'O',
            abdo_dia_nv: this.result[0].metric.abdo_dia_nv || 'O',
            abdo_sto_n: this.result[0].metric.abdo_sto_n || 'O',
            abdo_sto_ab: this.result[0].metric.abdo_sto_ab || 'O',
            abdo_sto_nv: this.result[0].metric.abdo_sto_nv || 'O',
            abdo_bowel_n: this.result[0].metric.abdo_bowel_n || 'O',
            abdo_bowel_ab: this.result[0].metric.abdo_bowel_ab || 'O',
            abdo_bowel_nv: this.result[0].metric.abdo_bowel_nv || 'O',
            abdo_kidney_n: this.result[0].metric.abdo_kidney_n || 'O',
            abdo_kidney_ab: this.result[0].metric.abdo_kidney_ab || 'O',
            abdo_kidney_nv: this.result[0].metric.abdo_kidney_nv || 'O',
            abdo_unary_n: this.result[0].metric.abdo_unary_n || 'O',
            abdo_unary_ab: this.result[0].metric.abdo_unary_ab || 'O',
            abdo_unary_nv: this.result[0].metric.abdo_unary_nv || 'O',
            abdo_insert_n: this.result[0].metric.abdo_insert_n || 'O',
            abdo_insert_ab: this.result[0].metric.abdo_insert_ab || 'O',
            abdo_insert_nv: this.result[0].metric.abdo_insert_nv || 'O',
            abdo_vessel_n: this.result[0].metric.abdo_vessel_n || 'O',
            abdo_vessel_ab: this.result[0].metric.abdo_vessel_ab || 'O',
            abdo_vessel_nv: this.result[0].metric.abdo_vessel_nv || 'O',
            spine1: this.result[0].metric.spine1 || 'O',
            spine2: this.result[0].metric.spine2 || 'O',
            spine3: this.result[0].metric.spine3 || 'O',
            limbs_ra_n: this.result[0].metric.limbs_ra_n || 'O',
            limbs_ra_ab: this.result[0].metric.limbs_ra_ab || 'O',
            limbs_ra_nv: this.result[0].metric.limbs_ra_nv || 'O',
            limbs_rl_n: this.result[0].metric.limbs_rl_n || 'O',
            limbs_rl_ab: this.result[0].metric.limbs_rl_ab || 'O',
            limbs_rl_nv: this.result[0].metric.limbs_rl_nv || 'O',
            limbs_la_n: this.result[0].metric.limbs_la_n || 'O',
            limbs_la_ab: this.result[0].metric.limbs_la_ab || 'O',
            limbs_la_nv: this.result[0].metric.limbs_la_nv || 'O',
            limbs_ll_n: this.result[0].metric.limbs_ll_n || 'O',
            limbs_ll_ab: this.result[0].metric.limbs_ll_ab || 'O',
            limbs_ll_nv: this.result[0].metric.limbs_ll_nv || 'O',
          },
        });
        this.obs.getImage(this.result.data.ftimage).subscribe(
          (resSuccess) => {
            this.fullImage = resSuccess;
          },
          (resErr) => {}
        );
        console.log(this.form.value);
      },
      (resErr) => {}
    );
  }

  head() {
    this.form.patchValue({
      metric: {
        head_shape_n: 'O',
        head_shape_ab: 'O',
        head_shape_nv: 'O',
        head_cavum_n: 'O',
        head_cavum_ab: 'O',
        head_cavum_nv: 'O',
        head_midline_n: 'O',
        head_midline_ab: 'O',
        head_midline_nv: 'O',
        head_thalami_n: 'O',
        head_thalami_ab: 'O',
        head_thalami_nv: 'O',
        head_lateral_n: 'O',
        head_lateral_ab: 'O',
        head_lateral_nv: 'O',
        head_cere_n: 'O',
        head_cere_ab: 'O',
        head_cere_nv: 'O',
      },
    });
  }
  face() {
    this.form.patchValue({
      metric: {
        face_upp_n: 'O',
        face_upp_ab: 'O',
        face_upp_nv: 'O',
        face_orbit_n: 'O',
        face_orbit_ab: 'O',
        face_orbit_nv: 'O',
        face_nose_n: 'O',
        face_nose_ab: 'O',
        face_nose_nv: 'O',
      },
    });
  }

  neck() {
    this.form.patchValue({
      metric: {
        neck1: 'O',
        neck2: 'O',
        neck3: 'O',
      },
    });
  }
  tho() {
    this.form.patchValue({
      metric: {
        tho_shape_n: 'O',
        tho_shape_ab: 'O',
        tho_shape_nv: 'O',
        tho_mass_n: 'O',
        tho_mass_ab: 'O',
        tho_mass_nv: 'O',
      },
    });
  }
  heart() {
    this.form.patchValue({
      metric: {
        heart_activity_n: 'O',
        heart_activity_ab: 'O',
        heart_activity_nv: 'O',
        heart_size_n: 'O',
        heart_size_ab: 'O',
        heart_size_nv: 'O',
        heart_cadic_n: 'O',
        heart_cadic_ab: 'O',
        heart_cadic_nv: 'O',
        heart_chamber_n: 'O',
        heart_chamber_ab: 'O',
        heart_chamber_nv: 'O',
      },
    });
  }
  spine() {
    this.form.patchValue({
      metric: {
        spine1: 'O',
        spine2: 'O',
        spine3: 'O',
      },
    });
  }

  limb() {
    this.form.patchValue({
      metric: {
        limbs_ra_n: 'O',
        limbs_ra_ab: 'O',
        limbs_ra_nv: 'O',
        limbs_rl_n: 'O',
        limbs_rl_ab: 'O',
        limbs_rl_nv: 'O',
        limbs_la_n: 'O',
        limbs_la_ab: 'O',
        limbs_la_nv: 'O',
        limbs_ll_n: 'O',
        limbs_ll_ab: 'O',
        limbs_ll_nv: 'O',
      },
    });
  }
  ab() {
    this.form.patchValue({
      metric: {
        abdo_dia_n: 'O',
        abdo_dia_ab: 'O',
        abdo_dia_nv: 'O',
        abdo_sto_n: 'O',
        abdo_sto_ab: 'O',
        abdo_sto_nv: 'O',
        abdo_bowel_n: 'O',
        abdo_bowel_ab: 'O',
        abdo_bowel_nv: 'O',
        abdo_kidney_n: 'O',
        abdo_kidney_ab: 'O',
        abdo_kidney_nv: 'O',
        abdo_unary_n: 'O',
        abdo_unary_ab: 'O',
        abdo_unary_nv: 'O',
        abdo_insert_n: 'O',
        abdo_insert_ab: 'O',
        abdo_insert_nv: 'O',
        abdo_vessel_n: 'O',
        abdo_vessel_ab: 'O',
        abdo_vessel_nv: 'O',
      },
    });
  }

  add() {
    if (this.fetus == 'A') {
      this.result.splice(0, 1, this.form.value);
      this._snackBar.open('Fetus A added', '', {
        duration: 2000,
        verticalPosition: 'top',
      });
    } else if (this.fetus == 'B') {
      this.result.splice(1, 1, this.form.value);
      this._snackBar.open('Fetus B added', '', {
        duration: 2000,
        verticalPosition: 'top',
      });
      console.log('splice');
    } else if (this.fetus == 'C') {
      this.result.splice(2, 1, this.form.value);
      this._snackBar.open('Fetus C added', '', {
        duration: 2000,
        verticalPosition: 'top',
      });
    } else {
      this._snackBar.open('Please select fetus', '', {
        duration: 2000,
        verticalPosition: 'top',
      });
    }
    console.log(this.data);
    console.log(this.fetus);
  }

  changeFetus(event) {
    if (this.fetus == 'A') {
      if (
        this.result[0].data.conclusion1 === 'false' ||
        this.result[0].data.conclusion1 === ''
      ) {
        this.form.patchValue({
          data: {
            conclusion1: false,
          },
        });
      } else {
        this.form.patchValue({
          data: {
            conclusion1: true,
          },
        });
      }
      if (
        this.result[0].data.conclusion2 === 'false' ||
        this.result[0].data.conclusion2 === ''
      ) {
        this.form.patchValue({
          data: {
            conclusion2: false,
          },
        });
      } else {
        this.form.patchValue({
          data: {
            conclusion2: true,
          },
        });
      }
      if (
        this.result[0].data.conclusion3 === 'false' ||
        this.result[0].data.conclusion3 === ''
      ) {
        this.form.patchValue({
          data: {
            conclusion3: false,
          },
        });
      } else {
        this.form.patchValue({
          data: {
            conclusion3: true,
          },
        });
      }
      this.form.patchValue({
        data: {
          STremester_id: this.result[0].data.STremester_id,
          lmp: this.result[0].data.lmp,
          ga: this.result[0].data.ga,
          edd: this.result[0].data.edd,
          tech_cond: this.result[0].data.tech_cond,
          no_of_fetus: this.result[0].data.no_of_fetus,
          chorionicity: this.result[0].data.chorionicity,
          p_location: this.result[0].data.p_location,
          cervicalos: this.result[0].data.cervicalos,
          fetal_mment: this.result[0].data.fetal_mment,
          a_fluid: this.result[0].data.a_fluid,
          sex: this.result[0].data.sex,
          bd_mm: this.result[0].data.bd_mm,
          bd_ga: this.result[0].data.bd_ga,
          fdl_mm: this.result[0].data.fdl_mm,
          fdl_ga: this.result[0].data.fdl_ga,
          ac_mm: this.result[0].data.ac_mm,
          ac_ga: this.result[0].data.ac_ga,
          hc_mm: this.result[0].data.hc_mm,
          hc_ga: this.result[0].data.hc_ga,
          g_age: this.result[0].data.g_age,
          efw: this.result[0].data.efw,
          exdd: this.result[0].data.exdd,
          finding: this.result[0].data.finding,
          fetus: this.result[0].data.fetus,
          ftimage: this.result[0].data.ftimage,
          fin_year: this.result[0].data.fin_year,
          entry_date: this.result[0].data.entry_date,
          update_entry_date: this.result[0].data.update_entry_date,
          doctor_id: this.result[0].data.doctor_id,
        },
        metric: {
          cat_id: this.result[0].metric.cat_id,
          STremester_id: this.result[0].metric.STremester_id,
          head_shape_n: this.result[0].metric.head_shape_n || 'O',
          head_shape_ab: this.result[0].metric.head_shape_ab || 'O',
          head_shape_nv: this.result[0].metric.head_shape_nv || 'O',
          head_cavum_n: this.result[0].metric.head_cavum_n || 'O',
          head_cavum_ab: this.result[0].metric.head_cavum_ab || 'O',
          head_cavum_nv: this.result[0].metric.head_cavum_nv || 'O',
          head_midline_n: this.result[0].metric.head_midline_n || 'O',
          head_midline_ab: this.result[0].metric.head_midline_ab || 'O',
          head_midline_nv: this.result[0].metric.head_midline_nv || 'O',
          head_thalami_n: this.result[0].metric.head_thalami_n || 'O',
          head_thalami_ab: this.result[0].metric.head_thalami_ab || 'O',
          head_thalami_nv: this.result[0].metric.head_thalami_nv || 'O',
          head_lateral_n: this.result[0].metric.head_lateral_n || 'O',
          head_lateral_ab: this.result[0].metric.head_lateral_ab || 'O',
          head_lateral_nv: this.result[0].metric.head_lateral_nv || 'O',
          head_cere_n: this.result[0].metric.head_cere_n || 'O',
          head_cere_ab: this.result[0].metric.head_cere_ab || 'O',
          head_cere_nv: this.result[0].metric.head_cere_nv || 'O',
          face_upp_n: this.result[0].metric.face_upp_n || 'O',
          face_upp_ab: this.result[0].metric.face_upp_ab || 'O',
          face_upp_nv: this.result[0].metric.face_upp_nv || 'O',
          face_orbit_n: this.result[0].metric.face_orbit_n || 'O',
          face_orbit_ab: this.result[0].metric.face_orbit_ab || 'O',
          face_orbit_nv: this.result[0].metric.face_orbit_nv || 'O',
          face_nose_n: this.result[0].metric.face_nose_n || 'O',
          face_nose_ab: this.result[0].metric.face_nose_ab || 'O',
          face_nose_nv: this.result[0].metric.face_nose_nv || 'O',
          neck1: this.result[0].metric.neck1 || 'O',
          neck2: this.result[0].metric.neck2 || 'O',
          neck3: this.result[0].metric.neck3 || 'O',
          tho_shape_n: this.result[0].metric.tho_shape_n || 'O',
          tho_shape_ab: this.result[0].metric.tho_shape_ab || 'O',
          tho_shape_nv: this.result[0].metric.tho_shape_nv || 'O',
          tho_mass_n: this.result[0].metric.tho_mass_n || 'O',
          tho_mass_ab: this.result[0].metric.tho_mass_ab || 'O',
          tho_mass_nv: this.result[0].metric.tho_mass_nv || 'O',
          heart_activity_n: this.result[0].metric.heart_activity_n || 'O',
          heart_activity_ab: this.result[0].metric.heart_activity_ab || 'O',
          heart_activity_nv: this.result[0].metric.heart_activity_nv || 'O',
          heart_size_n: this.result[0].metric.heart_size_n || 'O',
          heart_size_ab: this.result[0].metric.heart_size_ab || 'O',
          heart_size_nv: this.result[0].metric.heart_size_nv || 'O',
          heart_cadic_n: this.result[0].metric.heart_cadic_n || 'O',
          heart_cadic_ab: this.result[0].metric.heart_cadic_ab || 'O',
          heart_cadic_nv: this.result[0].metric.heart_cadic_nv || 'O',
          heart_chamber_n: this.result[0].metric.heart_chamber_n || 'O',
          heart_chamber_ab: this.result[0].metric.heart_chamber_ab || 'O',
          heart_chamber_nv: this.result[0].metric.heart_chamber_nv || 'O',
          abdo_dia_n: this.result[0].metric.abdo_dia_n || 'O',
          abdo_dia_ab: this.result[0].metric.abdo_dia_ab || 'O',
          abdo_dia_nv: this.result[0].metric.abdo_dia_nv || 'O',
          abdo_sto_n: this.result[0].metric.abdo_sto_n || 'O',
          abdo_sto_ab: this.result[0].metric.abdo_sto_ab || 'O',
          abdo_sto_nv: this.result[0].metric.abdo_sto_nv || 'O',
          abdo_bowel_n: this.result[0].metric.abdo_bowel_n || 'O',
          abdo_bowel_ab: this.result[0].metric.abdo_bowel_ab || 'O',
          abdo_bowel_nv: this.result[0].metric.abdo_bowel_nv || 'O',
          abdo_kidney_n: this.result[0].metric.abdo_kidney_n || 'O',
          abdo_kidney_ab: this.result[0].metric.abdo_kidney_ab || 'O',
          abdo_kidney_nv: this.result[0].metric.abdo_kidney_nv || 'O',
          abdo_unary_n: this.result[0].metric.abdo_unary_n || 'O',
          abdo_unary_ab: this.result[0].metric.abdo_unary_ab || 'O',
          abdo_unary_nv: this.result[0].metric.abdo_unary_nv || 'O',
          abdo_insert_n: this.result[0].metric.abdo_insert_n || 'O',
          abdo_insert_ab: this.result[0].metric.abdo_insert_ab || 'O',
          abdo_insert_nv: this.result[0].metric.abdo_insert_nv || 'O',
          abdo_vessel_n: this.result[0].metric.abdo_vessel_n || 'O',
          abdo_vessel_ab: this.result[0].metric.abdo_vessel_ab || 'O',
          abdo_vessel_nv: this.result[0].metric.abdo_vessel_nv || 'O',
          spine1: this.result[0].metric.spine1 || 'O',
          spine2: this.result[0].metric.spine2 || 'O',
          spine3: this.result[0].metric.spine3 || 'O',
          limbs_ra_n: this.result[0].metric.limbs_ra_n || 'O',
          limbs_ra_ab: this.result[0].metric.limbs_ra_ab || 'O',
          limbs_ra_nv: this.result[0].metric.limbs_ra_nv || 'O',
          limbs_rl_n: this.result[0].metric.limbs_rl_n || 'O',
          limbs_rl_ab: this.result[0].metric.limbs_rl_ab || 'O',
          limbs_rl_nv: this.result[0].metric.limbs_rl_nv || 'O',
          limbs_la_n: this.result[0].metric.limbs_la_n || 'O',
          limbs_la_ab: this.result[0].metric.limbs_la_ab || 'O',
          limbs_la_nv: this.result[0].metric.limbs_la_nv || 'O',
          limbs_ll_n: this.result[0].metric.limbs_ll_n || 'O',
          limbs_ll_ab: this.result[0].metric.limbs_ll_ab || 'O',
          limbs_ll_nv: this.result[0].metric.limbs_ll_nv || 'O',
        },
      });
    } else if (this.fetus == 'B') {
      if (
        this.result[1].data.conclusion1 === 'false' ||
        this.result[1].data.conclusion1 === ''
      ) {
        this.form.patchValue({
          data: {
            conclusion1: false,
          },
        });
      } else {
        this.form.patchValue({
          data: {
            conclusion1: true,
          },
        });
      }
      if (
        this.result[1].data.conclusion2 === 'false' ||
        this.result[1].data.conclusion2 === ''
      ) {
        this.form.patchValue({
          data: {
            conclusion2: false,
          },
        });
      } else {
        this.form.patchValue({
          data: {
            conclusion2: true,
          },
        });
      }
      if (
        this.result[1].data.conclusion3 === 'false' ||
        this.result[1].data.conclusion3 === ''
      ) {
        this.form.patchValue({
          data: {
            conclusion3: false,
          },
        });
      } else {
        this.form.patchValue({
          data: {
            conclusion3: true,
          },
        });
      }
      this.form.patchValue({
        data: {
          STremester_id: this.result[1].data.STremester_id,
          lmp: this.result[1].data.lmp,
          ga: this.result[1].data.ga,
          edd: this.result[1].data.edd,
          tech_cond: this.result[1].data.tech_cond,
          no_of_fetus: this.result[1].data.no_of_fetus,
          chorionicity: this.result[1].data.chorionicity,
          p_location: this.result[1].data.p_location,
          cervicalos: this.result[1].data.cervicalos,
          fetal_mment: this.result[1].data.fetal_mment,
          a_fluid: this.result[1].data.a_fluid,
          bd_mm: this.result[1].data.bd_mm,
          sex: this.result[1].data.sex,
          bd_ga: this.result[1].data.bd_ga,
          fdl_mm: this.result[1].data.fdl_mm,
          fdl_ga: this.result[1].data.fdl_ga,
          ac_mm: this.result[1].data.ac_mm,
          ac_ga: this.result[1].data.ac_ga,
          hc_mm: this.result[1].data.hc_mm,
          hc_ga: this.result[1].data.hc_ga,
          g_age: this.result[1].data.g_age,
          efw: this.result[1].data.efw,
          exdd: this.result[1].data.exdd,
          finding: this.result[1].data.finding,
          fetus: this.result[1].data.fetus,
          ftimage: this.result[1].data.ftimage,
          fin_year: this.result[1].data.fin_year,
          entry_date: this.result[1].data.entry_date,
          update_entry_date: this.result[1].data.update_entry_date,
          doctor_id: this.result[1].data.doctor_id,
        },
        metric: {
          cat_id: this.result[1].metric.cat_id,
          STremester_id: this.result[1].metric.STremester_id,
          head_shape_n: this.result[1].metric.head_shape_n || 'O',
          head_shape_ab: this.result[1].metric.head_shape_ab || 'O',
          head_shape_nv: this.result[1].metric.head_shape_nv || 'O',
          head_cavum_n: this.result[1].metric.head_cavum_n || 'O',
          head_cavum_ab: this.result[1].metric.head_cavum_ab || 'O',
          head_cavum_nv: this.result[1].metric.head_cavum_nv || 'O',
          head_midline_n: this.result[1].metric.head_midline_n || 'O',
          head_midline_ab: this.result[1].metric.head_midline_ab || 'O',
          head_midline_nv: this.result[1].metric.head_midline_nv || 'O',
          head_thalami_n: this.result[1].metric.head_thalami_n || 'O',
          head_thalami_ab: this.result[1].metric.head_thalami_ab || 'O',
          head_thalami_nv: this.result[1].metric.head_thalami_nv || 'O',
          head_lateral_n: this.result[1].metric.head_lateral_n || 'O',
          head_lateral_ab: this.result[1].metric.head_lateral_ab || 'O',
          head_lateral_nv: this.result[1].metric.head_lateral_nv || 'O',
          head_cere_n: this.result[1].metric.head_cere_n || 'O',
          head_cere_ab: this.result[1].metric.head_cere_ab || 'O',
          head_cere_nv: this.result[1].metric.head_cere_nv || 'O',
          face_upp_n: this.result[1].metric.face_upp_n || 'O',
          face_upp_ab: this.result[1].metric.face_upp_ab || 'O',
          face_upp_nv: this.result[1].metric.face_upp_nv || 'O',
          face_orbit_n: this.result[1].metric.face_orbit_n || 'O',
          face_orbit_ab: this.result[1].metric.face_orbit_ab || 'O',
          face_orbit_nv: this.result[1].metric.face_orbit_nv || 'O',
          face_nose_n: this.result[1].metric.face_nose_n || 'O',
          face_nose_ab: this.result[1].metric.face_nose_ab || 'O',
          face_nose_nv: this.result[1].metric.face_nose_nv || 'O',
          neck1: this.result[1].metric.neck1 || 'O',
          neck2: this.result[1].metric.neck2 || 'O',
          neck3: this.result[1].metric.neck3 || 'O',
          tho_shape_n: this.result[1].metric.tho_shape_n || 'O',
          tho_shape_ab: this.result[1].metric.tho_shape_ab || 'O',
          tho_shape_nv: this.result[1].metric.tho_shape_nv || 'O',
          tho_mass_n: this.result[1].metric.tho_mass_n || 'O',
          tho_mass_ab: this.result[1].metric.tho_mass_ab || 'O',
          tho_mass_nv: this.result[1].metric.tho_mass_nv || 'O',
          heart_activity_n: this.result[1].metric.heart_activity_n || 'O',
          heart_activity_ab: this.result[1].metric.heart_activity_ab || 'O',
          heart_activity_nv: this.result[1].metric.heart_activity_nv || 'O',
          heart_size_n: this.result[1].metric.heart_size_n || 'O',
          heart_size_ab: this.result[1].metric.heart_size_ab || 'O',
          heart_size_nv: this.result[1].metric.heart_size_nv || 'O',
          heart_cadic_n: this.result[1].metric.heart_cadic_n || 'O',
          heart_cadic_ab: this.result[1].metric.heart_cadic_ab || 'O',
          heart_cadic_nv: this.result[1].metric.heart_cadic_nv || 'O',
          heart_chamber_n: this.result[1].metric.heart_chamber_n || 'O',
          heart_chamber_ab: this.result[1].metric.heart_chamber_ab || 'O',
          heart_chamber_nv: this.result[1].metric.heart_chamber_nv || 'O',
          abdo_dia_n: this.result[1].metric.abdo_dia_n || 'O',
          abdo_dia_ab: this.result[1].metric.abdo_dia_ab || 'O',
          abdo_dia_nv: this.result[1].metric.abdo_dia_nv || 'O',
          abdo_sto_n: this.result[1].metric.abdo_sto_n || 'O',
          abdo_sto_ab: this.result[1].metric.abdo_sto_ab || 'O',
          abdo_sto_nv: this.result[1].metric.abdo_sto_nv || 'O',
          abdo_bowel_n: this.result[1].metric.abdo_bowel_n || 'O',
          abdo_bowel_ab: this.result[1].metric.abdo_bowel_ab || 'O',
          abdo_bowel_nv: this.result[1].metric.abdo_bowel_nv || 'O',
          abdo_kidney_n: this.result[1].metric.abdo_kidney_n || 'O',
          abdo_kidney_ab: this.result[1].metric.abdo_kidney_ab || 'O',
          abdo_kidney_nv: this.result[1].metric.abdo_kidney_nv || 'O',
          abdo_unary_n: this.result[1].metric.abdo_unary_n || 'O',
          abdo_unary_ab: this.result[1].metric.abdo_unary_ab || 'O',
          abdo_unary_nv: this.result[1].metric.abdo_unary_nv || 'O',
          abdo_insert_n: this.result[1].metric.abdo_insert_n || 'O',
          abdo_insert_ab: this.result[1].metric.abdo_insert_ab || 'O',
          abdo_insert_nv: this.result[1].metric.abdo_insert_nv || 'O',
          abdo_vessel_n: this.result[1].metric.abdo_vessel_n || 'O',
          abdo_vessel_ab: this.result[1].metric.abdo_vessel_ab || 'O',
          abdo_vessel_nv: this.result[1].metric.abdo_vessel_nv || 'O',
          spine1: this.result[1].metric.spine1 || 'O',
          spine2: this.result[1].metric.spine2 || 'O',
          spine3: this.result[1].metric.spine3 || 'O',
          limbs_ra_n: this.result[1].metric.limbs_ra_n || 'O',
          limbs_ra_ab: this.result[1].metric.limbs_ra_ab || 'O',
          limbs_ra_nv: this.result[1].metric.limbs_ra_nv || 'O',
          limbs_rl_n: this.result[1].metric.limbs_rl_n || 'O',
          limbs_rl_ab: this.result[1].metric.limbs_rl_ab || 'O',
          limbs_rl_nv: this.result[1].metric.limbs_rl_nv || 'O',
          limbs_la_n: this.result[1].metric.limbs_la_n || 'O',
          limbs_la_ab: this.result[1].metric.limbs_la_ab || 'O',
          limbs_la_nv: this.result[1].metric.limbs_la_nv || 'O',
          limbs_ll_n: this.result[1].metric.limbs_ll_n || 'O',
          limbs_ll_ab: this.result[1].metric.limbs_ll_ab || 'O',
          limbs_ll_nv: this.result[1].metric.limbs_ll_nv || 'O',
        },
      });
    } else if (this.fetus == 'C') {
      if (
        this.result[2].data.conclusion1 === 'false' ||
        this.result[2].data.conclusion1 === ''
      ) {
        this.form.patchValue({
          data: {
            conclusion1: false,
          },
        });
      } else {
        this.form.patchValue({
          data: {
            conclusion1: true,
          },
        });
      }
      if (
        this.result[2].data.conclusion2 === 'false' ||
        this.result[2].data.conclusion2 === ''
      ) {
        this.form.patchValue({
          data: {
            conclusion2: false,
          },
        });
      } else {
        this.form.patchValue({
          data: {
            conclusion2: true,
          },
        });
      }
      if (
        this.result[2].data.conclusion3 === 'false' ||
        this.result[2].data.conclusion3 === ''
      ) {
        this.form.patchValue({
          data: {
            conclusion3: false,
          },
        });
      } else {
        this.form.patchValue({
          data: {
            conclusion3: true,
          },
        });
      }
      this.form.patchValue({
        data: {
          STremester_id: this.result[2].data.STremester_id,
          lmp: this.result[2].data.lmp,
          ga: this.result[2].data.ga,
          edd: this.result[2].data.edd,
          tech_cond: this.result[2].data.tech_cond,
          no_of_fetus: this.result[2].data.no_of_fetus,
          chorionicity: this.result[2].data.chorionicity,
          p_location: this.result[2].data.p_location,
          cervicalos: this.result[2].data.cervicalos,
          fetal_mment: this.result[2].data.fetal_mment,
          a_fluid: this.result[2].data.a_fluid,
          bd_mm: this.result[2].data.bd_mm,
          bd_ga: this.result[2].data.bd_ga,
          fdl_mm: this.result[2].data.fdl_mm,
          fdl_ga: this.result[2].data.fdl_ga,
          sex: this.result[2].data.sex,
          ac_mm: this.result[2].data.ac_mm,
          ac_ga: this.result[2].data.ac_ga,
          hc_mm: this.result[2].data.hc_mm,
          hc_ga: this.result[2].data.hc_ga,
          g_age: this.result[2].data.g_age,
          efw: this.result[2].data.efw,
          exdd: this.result[2].data.exdd,
          finding: this.result[2].data.finding,
          fetus: this.result[2].data.fetus,
          ftimage: this.result[2].data.ftimage,
          fin_year: this.result[2].data.fin_year,
          entry_date: this.result[2].data.entry_date,
          update_entry_date: this.result[2].data.update_entry_date,
          doctor_id: this.result[2].data.doctor_id,
        },
        metric: {
          cat_id: this.result[2].metric.cat_id,
          STremester_id: this.result[2].metric.STremester_id,
          head_shape_n: this.result[2].metric.head_shape_n || 'O',
          head_shape_ab: this.result[2].metric.head_shape_ab || 'O',
          head_shape_nv: this.result[2].metric.head_shape_nv || 'O',
          head_cavum_n: this.result[2].metric.head_cavum_n || 'O',
          head_cavum_ab: this.result[2].metric.head_cavum_ab || 'O',
          head_cavum_nv: this.result[2].metric.head_cavum_nv || 'O',
          head_midline_n: this.result[2].metric.head_midline_n || 'O',
          head_midline_ab: this.result[2].metric.head_midline_ab || 'O',
          head_midline_nv: this.result[2].metric.head_midline_nv || 'O',
          head_thalami_n: this.result[2].metric.head_thalami_n || 'O',
          head_thalami_ab: this.result[2].metric.head_thalami_ab || 'O',
          head_thalami_nv: this.result[2].metric.head_thalami_nv || 'O',
          head_lateral_n: this.result[2].metric.head_lateral_n || 'O',
          head_lateral_ab: this.result[2].metric.head_lateral_ab || 'O',
          head_lateral_nv: this.result[2].metric.head_lateral_nv || 'O',
          head_cere_n: this.result[2].metric.head_cere_n || 'O',
          head_cere_ab: this.result[2].metric.head_cere_ab || 'O',
          head_cere_nv: this.result[2].metric.head_cere_nv || 'O',
          face_upp_n: this.result[2].metric.face_upp_n || 'O',
          face_upp_ab: this.result[2].metric.face_upp_ab || 'O',
          face_upp_nv: this.result[2].metric.face_upp_nv || 'O',
          face_orbit_n: this.result[2].metric.face_orbit_n || 'O',
          face_orbit_ab: this.result[2].metric.face_orbit_ab || 'O',
          face_orbit_nv: this.result[2].metric.face_orbit_nv || 'O',
          face_nose_n: this.result[2].metric.face_nose_n || 'O',
          face_nose_ab: this.result[2].metric.face_nose_ab || 'O',
          face_nose_nv: this.result[2].metric.face_nose_nv || 'O',
          neck1: this.result[2].metric.neck1 || 'O',
          neck2: this.result[2].metric.neck2 || 'O',
          neck3: this.result[2].metric.neck3 || 'O',
          tho_shape_n: this.result[2].metric.tho_shape_n || 'O',
          tho_shape_ab: this.result[2].metric.tho_shape_ab || 'O',
          tho_shape_nv: this.result[2].metric.tho_shape_nv || 'O',
          tho_mass_n: this.result[2].metric.tho_mass_n || 'O',
          tho_mass_ab: this.result[2].metric.tho_mass_ab || 'O',
          tho_mass_nv: this.result[2].metric.tho_mass_nv || 'O',
          heart_activity_n: this.result[2].metric.heart_activity_n || 'O',
          heart_activity_ab: this.result[2].metric.heart_activity_ab || 'O',
          heart_activity_nv: this.result[2].metric.heart_activity_nv || 'O',
          heart_size_n: this.result[2].metric.heart_size_n || 'O',
          heart_size_ab: this.result[2].metric.heart_size_ab || 'O',
          heart_size_nv: this.result[2].metric.heart_size_nv || 'O',
          heart_cadic_n: this.result[2].metric.heart_cadic_n || 'O',
          heart_cadic_ab: this.result[2].metric.heart_cadic_ab || 'O',
          heart_cadic_nv: this.result[2].metric.heart_cadic_nv || 'O',
          heart_chamber_n: this.result[2].metric.heart_chamber_n || 'O',
          heart_chamber_ab: this.result[2].metric.heart_chamber_ab || 'O',
          heart_chamber_nv: this.result[2].metric.heart_chamber_nv || 'O',
          abdo_dia_n: this.result[2].metric.abdo_dia_n || 'O',
          abdo_dia_ab: this.result[2].metric.abdo_dia_ab || 'O',
          abdo_dia_nv: this.result[2].metric.abdo_dia_nv || 'O',
          abdo_sto_n: this.result[2].metric.abdo_sto_n || 'O',
          abdo_sto_ab: this.result[2].metric.abdo_sto_ab || 'O',
          abdo_sto_nv: this.result[2].metric.abdo_sto_nv || 'O',
          abdo_bowel_n: this.result[2].metric.abdo_bowel_n || 'O',
          abdo_bowel_ab: this.result[2].metric.abdo_bowel_ab || 'O',
          abdo_bowel_nv: this.result[2].metric.abdo_bowel_nv || 'O',
          abdo_kidney_n: this.result[2].metric.abdo_kidney_n || 'O',
          abdo_kidney_ab: this.result[2].metric.abdo_kidney_ab || 'O',
          abdo_kidney_nv: this.result[2].metric.abdo_kidney_nv || 'O',
          abdo_unary_n: this.result[2].metric.abdo_unary_n || 'O',
          abdo_unary_ab: this.result[2].metric.abdo_unary_ab || 'O',
          abdo_unary_nv: this.result[2].metric.abdo_unary_nv || 'O',
          abdo_insert_n: this.result[2].metric.abdo_insert_n || 'O',
          abdo_insert_ab: this.result[2].metric.abdo_insert_ab || 'O',
          abdo_insert_nv: this.result[2].metric.abdo_insert_nv || 'O',
          abdo_vessel_n: this.result[2].metric.abdo_vessel_n || 'O',
          abdo_vessel_ab: this.result[2].metric.abdo_vessel_ab || 'O',
          abdo_vessel_nv: this.result[2].metric.abdo_vessel_nv || 'O',
          spine1: this.result[2].metric.spine1 || 'O',
          spine2: this.result[2].metric.spine2 || 'O',
          spine3: this.result[2].metric.spine3 || 'O',
          limbs_ra_n: this.result[2].metric.limbs_ra_n || 'O',
          limbs_ra_ab: this.result[2].metric.limbs_ra_ab || 'O',
          limbs_ra_nv: this.result[2].metric.limbs_ra_nv || 'O',
          limbs_rl_n: this.result[2].metric.limbs_rl_n || 'O',
          limbs_rl_ab: this.result[2].metric.limbs_rl_ab || 'O',
          limbs_rl_nv: this.result[2].metric.limbs_rl_nv || 'O',
          limbs_la_n: this.result[2].metric.limbs_la_n || 'O',
          limbs_la_ab: this.result[2].metric.limbs_la_ab || 'O',
          limbs_la_nv: this.result[2].metric.limbs_la_nv || 'O',
          limbs_ll_n: this.result[2].metric.limbs_ll_n || 'O',
          limbs_ll_ab: this.result[2].metric.limbs_ll_ab || 'O',
          limbs_ll_nv: this.result[2].metric.limbs_ll_nv || 'O',
        },
      });
    }
    console.log(this.data);
  }

  getProp(prop) {
    return this[prop];
  }
  setProp(prop, value) {
    this[prop] = value;
  }

  DateChange(event: any) {
    this.form.patchValue({
      data: {
        entry_date: moment(event.target.value).format('YYYY-MM-DD'),
      },
    });
    console.log(this.form.value);
  }
  slectOnChange1(event) {
    this.firstPic = event.value;
    this.disabled = false;
  }
  slectOnChange(event) {
    let fullPic = this.firstPic + '/' + event.value + '.jpg';
    this.form.patchValue({
      data: {
        ftimage: fullPic,
      },
    });
    this.obs.getImage(fullPic).subscribe(
      (resSuccess) => {
        this.fullImage = resSuccess;
        console.log(resSuccess);
      },
      (resErr) => {}
    );
    console.log(this.form.value);
  }

  onSubmit(e) {
    // e.preventDefault();
    this.isLoading = true;
    // const {
    //   result_id,
    //   data,
    //   metric
    // } = this.form.value;
    console.log(this.result);

    this.obs.postST(this.result).subscribe(
      (resSuccess: []) => {
        this.response = resSuccess;
        this.isLoading = false;
        console.log(resSuccess);

        if (this.response.success) {
          this.form.reset();
          this.isLoading = false;
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this.isLoading = false;
          this._snackBar.open('Error: Please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resSuccess);
        }
      },
      (resErr) => {
        this.isLoading = false;
        this._snackBar.open(resErr, '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resErr);
      }
    );
  }
}
